import { Component } from '@mycolorway/tao';

Component('tr-formatted-number', {
  properties: {
    num: {
      type: Number,
      default: NaN,
    },
    formats: {
      type: String,
      default: 'none',
    },
    decimals: {
      type: Number,
      default: 2,
    },
    symbol: String,
    position: {
      type: String,
      default: 'prefix',
    },
  },

  connected() {
    if (Number.isNaN(this.num)) {
      this.num = parseFloat(this.textContent.trim());
    }
    this.format();
  },

  format() {
    if (Number.isNaN(this.num)) return;

    let { symbol, position } = this;
    switch (this.formats) {
      case 'standard':
        symbol = '';
        position = 'prefix';
        break;
      case 'percent':
        symbol = '%';
        position = 'suffix';
        break;
      case 'CNY':
        symbol = '¥';
        position = 'prefix';
        break;
      case 'USD':
        symbol = '$';
        position = 'prefix';
        break;
      case 'EUR':
        symbol = '€';
        position = 'prefix';
        break;
      case 'custom':
        break;
      default:
        this.textContent = this.num;
        return;
    }

    this.textContent = format(this.num, {
      decimals: this.decimals, symbol, position,
    });
  },
});

function format(num, { decimals = 2, symbol = '', position = 'prefix' } = {}) {
  const text = String(round(num, decimals).toFixed(decimals));
  const formatted = text.replace(/\d(?=(\d{3})+\.)/g, '$&,');
  return position === 'suffix' ? `${formatted}${symbol}` : `${symbol}${formatted}`;
}

function round(value, decimals) {
  return Number(`${Math.round(`${value}e${decimals}`)}e-${decimals}`);
}
